<template>
  <div class="nav-layer"></div>
  <section class="header"  :class="{ 'is-scrolled': isScrolled }">
    <div class="container" id="goheadspe">
      <div class="user-header" >
        <div class="logo">
          <!-- <a href="index.html"></a> -->
          <router-link to="/"> <img :src="logo" alt="logo" /> </router-link>

        </div>
        <div class="flex-logins">
          <ul class="user-ul" :class="{ slideto: showSide }">
            <li>
              <router-link @click="scrollToTop" :to="{ path: '/', hash: '#goheadspe' }">{{ $t('pageHeader.home') }}</router-link>
            </li>

            <li>
              <router-link @click="scrollToTop" :to="{ path: '/', hash: '#gomain' }">{{ $t('pageHeader.aboutUs') }}</router-link>
            </li>

            <li>
              <router-link :to="{ path: '/', hash: '#gospecial' }">{{ $t('pageHeader.ourFeatures') }}</router-link>
            </li>

            <li>
              <router-link :to="{ path: '/', hash: '#gosteps' }">{{ $t('pageHeader.orderSteps') }}</router-link>
            </li>
            <li><router-link to="/contactView"> {{ $t('pageHeader.contactUs') }} </router-link></li>
          </ul>
        </div>
        <div class="header-language">
          <div class="logins">
            <router-link to="/loginView" class="main-btn up bg-trans">{{ $t('pageHeader.login') }}</router-link>
          </div>
          <router-link to="/registerView" class="main-btn up">{{ $t('pageHeader.register') }}</router-link>
          <div class="d-flex align-items-center">
            <!--ar-->
            <div class="drop-header px-3 py-2 font15 pointer-click" v-if="showArbic == 'ar'">
              عربي
              <i class="fa-solid fa-chevron-down"></i>
              <div class="drop-down-lang">
                <ul>
                  <li @click="setArabic()"><a href="#" class="activeLang">عربي</a></li>
                  <li @click="setEnglish()"> <a href="#">English</a></li>
                </ul>
              </div>
            </div>
            <!--en-->
            <div class="drop-header px-3 py-2 font15 pointer-click" v-else>
              English
              <i class="fa-solid fa-chevron-down"></i>
              <div class="drop-down-lang">
                <ul>
                  <li @click="setEnglish()"><a href="#" class="activeLang">English</a></li>
                  <li @click="setArabic()"><a href="#">اللغة العربية</a></li>
                </ul>
              </div>
            </div>
          </div>
          <span class="coll-icon" @click="toggleSideBar" :class="{ active: showSide }">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      showArbic: "ar",
      showSide: false,
      logo: require("../assets/imgs/logo.png"),
      isScrolled: false,
    };
  },

  methods: {
       handleScroll() {
      this.isScrolled = window.scrollY >= 100;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // change language and local
    setArabic() {
      localStorage.setItem("locale", "ar");
      localStorage.setItem("lang", "ar");
      // setTimeout(() => {
      //   this.$i18n.locale = "ar";
      // }, 3000);

      // this.showArbic = this.$i18n.locale;
      location.reload();
    },
    setEnglish() {
      localStorage.setItem("locale", "en");
      localStorage.setItem("lang", "en");
      // setTimeout(() => {
      //   this.$i18n.locale = "en";
      // }, 3000);

      location.reload();
    },

    toggleSideBar() {
      this.showSide = !this.showSide;
    },



  },
  mounted() {
    this.showArbic = localStorage.getItem("locale");
    localStorage.setItem("lang", localStorage.getItem("locale"));
    if (localStorage.getItem("locale") === null) {
      localStorage.setItem("locale", "ar");
    }


        // ✅ scroll listener
    this.handleScroll(); // عشان لو الصفحة مفتوحة أصلاً على scroll
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },

    beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style></style>
